import { useEffect } from "react";
import Lenis from "lenis";

export default function SmoothScroll() {
  useEffect(() => {
    // Bail on browsers that lack the APIs Lenis relies on (very old iOS Safari, etc.)
    if (
      typeof window === "undefined" ||
      typeof ResizeObserver === "undefined" ||
      typeof requestAnimationFrame === "undefined"
    ) {
      return undefined;
    }
    // Respect the user's OS-level "Reduce motion" preference.
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return undefined;
    }
    let lenis;
    let rafId;
    try {
      lenis = new Lenis({
        duration: 1.15,
        smoothWheel: true,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      });
      window.__lenis = lenis;
      function raf(time) {
        lenis.raf(time);
        rafId = requestAnimationFrame(raf);
      }
      rafId = requestAnimationFrame(raf);
    } catch (_) {
      /* Fall back to native scrolling on unsupported browsers */
      return undefined;
    }
    return () => {
      if (rafId) cancelAnimationFrame(rafId);
      if (lenis && typeof lenis.destroy === "function") lenis.destroy();
    };
  }, []);
  return null;
}
